interface Props {
  [key: string]: any
}

export default function HomGraduationCapIcon(props: Props): React.ReactElement {
  const { pathClassName, ...rest } = props

  return (
    <svg fill="none" viewBox="0 0 48 48" {...rest} xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#hom-graduation-cap_clip0)">
        <path d="M46 16.8149H44V37.9999H46V16.8149Z" fill="#7D38D6" />
        <path
          d="M45 42.6C45 42.6 47 40.105 47 39C47 37.895 46.105 37 45 37C43.895 37 43 37.895 43 39C43 40.105 45 42.6 45 42.6Z"
          fill="#A37DD5"
        />
        <path
          d="M22.3522 28.385L0.65925 19.346C-0.21975 18.98 -0.21975 17.734 0.65925 17.368L22.3522 8.33C23.4072 7.89 24.5942 7.89 25.6493 8.33L47.3413 17.368C48.2203 17.734 48.2203 18.98 47.3413 19.346L25.6493 28.384C24.5933 28.824 23.4072 28.824 22.3522 28.385Z"
          fill="#7D38D6"
        />
        <path
          d="M24 18C15.716 18 9 19.439 9 21.214V35C17.571 35 24 39 24 39C24 39 30.429 35 39 35V21.214C39 19.439 32.284 18 24 18Z"
          fill="#A37DD5"
        />
      </g>
      <defs>
        <clipPath id="hom-graduation-cap_clip0">
          <rect fill="white" height="48" width="48" />
        </clipPath>
      </defs>
    </svg>
  )
}
